import { GET_HUBSPOT_VISITOR_IDENTIFICATION } from './operations'
import type { TCustomerAgentQueriesMap } from './types'

export const GRAPHQL_CUSTOMER_AGENT_QUERIES: TCustomerAgentQueriesMap = {
  getHubspotVisitorIdentification: GET_HUBSPOT_VISITOR_IDENTIFICATION,
}
